<!-- xs/sm L1 -->
<!-- xs/sm L2 -->
<div
  *ngIf="!showContactEmergency"
  class="digital-platform-hero-carousel digital-platform-carousel-mobile d-xs-block d-md-none {{
    isL2 && showBreadcrumbs ? 'show-breadcrumbs' : ''
  }}"
  [class.has-above-header]="hasAboveHeader"
  [class.has-header]="hasHeader"
  [class.has-caption]="hasCaption"
  [class.has-cta-button]="hasCtaButton"
>
  <ng-container *ngTemplateOutlet="mobileSectionTop"></ng-container>

  <div class="carousel-mobile-section-bottom">
    <ng-container *ngTemplateOutlet="mobileDuoTone"></ng-container>

    <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
  </div>
</div>

<div
  *ngIf="showContactEmergency"
  class="digital-platform-hero-carousel digital-platform-carousel-mobile show-contact-emergency d-xs-block d-md-none"
  [class.has-above-header]="hasAboveHeader"
  [class.has-header]="hasHeader"
  [class.has-caption]="hasCaption"
  [class.has-cta-button]="hasCtaButton"
  [class.has-controls]="hasControls"
  [class.has-breadcrumbs]="showBreadcrumbs"
>
  <ng-container *ngTemplateOutlet="mobileSectionTop"></ng-container>

  <div class="carousel-mobile-section-bottom show-contact-emergency">
    <ng-container *ngTemplateOutlet="mobileDuoTone"></ng-container>

    <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>

    <div *ngIf="showContactEmergency" class="carousel-contact-info">
      <div class="customer-service">
        <img alt="customer service" src="/assets/icons/customer-service.svg" />
        <div [innerHTML]="stringOrNullToString(overlayAlert1)"></div>
      </div>
      <div class="emergency-service">
        <img
          alt="emergency service"
          src="/assets/icons/emergency-service.svg"
        />
        <div [innerHTML]="stringOrNullToString(overlayAlert2)"></div>
      </div>
    </div>
  </div>
</div>

<!-- ======================================= -->
<!-- mdUp L1 -->
<ng-container *ngIf="isL1">
  <div
    class="digital-platform-hero-carousel digital-platform-carousel-l1-md-up d-none d-md-flex"
    [class.has-above-header]="hasAboveHeader"
    [class.has-header]="hasHeader"
    [class.has-caption]="hasCaption"
    [class.has-cta-button]="hasCtaButton"
    [class.has-controls]="hasControls"
    [class.has-breadcrumbs]="showBreadcrumbs"
  >
    <div class="carousel-left flex-grow-1 flex-shrink-1">
      <ng-container *ngTemplateOutlet="carouselImageTmp"></ng-container>

      <div *ngIf="showContactEmergency" class="carousel-contact-info">
        <div class="customer-service">
          <img
            alt="customer service"
            src="/assets/icons/customer-service.svg"
          />
          <div [innerHTML]="stringOrNullToString(overlayAlert1)"></div>
        </div>
        <div class="emergency-service">
          <img
            alt="emergency service"
            src="/assets/icons/emergency-service.svg"
          />
          <div [innerHTML]="stringOrNullToString(overlayAlert2)"></div>
        </div>
      </div>

      <div class="carousel-control-container" *ngIf="hasControls">
        <div class="carousel-controls">
          <button (click)="playPause()">
            <img
              alt="play/pause button"
              [src]="
                playing ? '/assets/icons/pause.svg' : '/assets/icons/play.svg'
              "
            />
          </button>
          <div class="carousel-slides">
            <div
              *ngFor="let image of carouselImage; let i = index"
              class="slide"
              [ngClass]="{ selected: activeIndex === i }"
              (click)="selectSlide(i)"
              role="button"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="carousel-right">
      <svg
        class="carousel-swoop {{ swooshOverlayColor.cssColorName }}"
        width="217"
        height="424"
        viewBox="0 0 217 424"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M217 424C165 424.107 141.131 389 130.744 365L22.5 41C18 26.5 6 6 0 0H217V424Z"
          fill=""
        />
      </svg>

      <div class="carousel-right-content pe-md-6 pe-lg-12">
        <div
          class="carousel-above-header"
          [innerHtml]="stringOrNullToString(textAboveTitle[activeIndex])"
        ></div>
        <h1
          class="carousel-header pb-3"
          [innerHTML]="stringOrNullToString(richTextTitle[activeIndex])"
        ></h1>
        <p
          class="carousel-right-caption pb-lg-3 pb-md-1"
          [innerHTML]="stringOrNullToString(description[activeIndex])"
        ></p>
        <div *ngIf="!!paragraphs">
          <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
        </div>
      </div>

      <div class="carousel-right-overlay">
        <ng-container *ngTemplateOutlet="translucentImageTmp"></ng-container>
      </div>
    </div>
  </div>
  <ng-container *ngIf="breadcrumbs">
    <div
      class="digital-platform-hero-carousel digital-platform-carousel-l2-md-breadcrumbs d-none d-md-flex container"
    >
      <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
    </div>
  </ng-container>
</ng-container>
<!-- ======================================= -->

<!-- ======================================= -->
<!-- mdUp L2 -->
<ng-container *ngIf="isL2">
  <div
    class="digital-platform-hero-carousel digital-platform-carousel-l2-md-up d-md-flex d-none position-relative bg-primary"
    [class.has-above-header]="hasAboveHeader"
    [class.has-header]="hasHeader"
    [class.has-caption]="hasCaption"
    [class.has-cta-button]="hasCtaButton"
    [class.has-controls]="hasControls"
    [class.has-breadcrumbs]="showBreadcrumbs"
  >
    <div class="container">
      <div class="carousel-left {{ fillColorToBgColor }}">
        <svg
          class="carousel-swoop {{ swooshOverlayColor.cssColorName }}"
          width="178"
          height="424"
          viewBox="0 0 178 424"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0L106.509 316.66C120.292 359.496 145.545 396.011 178 424H0V0Z"
            fill=""
          />
        </svg>
        <div class="carousel-left-content px-4">
          <div
            class="carousel-above-header"
            [innerHtml]="stringOrNullToString(textAboveTitle[activeIndex])"
          ></div>
          <h1
            class="carousel-header pb-3"
            [innerHTML]="stringOrNullToString(richTextTitle[activeIndex])"
          ></h1>
          <p
            class="carousel-left-caption pb-3"
            [innerHTML]="stringOrNullToString(description[activeIndex])"
          ></p>
          <div *ngIf="!!paragraphs">
            <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
          </div>
        </div>
        <div class="carousel-left-overlay">
          <ng-container *ngTemplateOutlet="translucentImageTmp"></ng-container>
        </div>
      </div>
    </div>

    <div
      class="carousel-right flex-grow-1 flex-shrink-1 position-absolute top-0 end-0"
    >
      <ng-container *ngTemplateOutlet="carouselImageTmp"></ng-container>
      <div *ngIf="showContactEmergency" class="carousel-contact-info">
        <div class="customer-service">
          <img
            alt="customer service"
            src="/assets/icons/customer-service.svg"
          />
          <div [innerHTML]="stringOrNullToString(overlayAlert1)"></div>
        </div>
        <div class="emergency-service">
          <img
            alt="emergency service"
            src="/assets/icons/emergency-service.svg"
          />
          <div [innerHTML]="stringOrNullToString(overlayAlert2)"></div>
        </div>
      </div>
      <div class="carousel-control-container" *ngIf="hasControls">
        <div class="carousel-controls">
          <button (click)="playPause()">
            <img
              alt="play/pause button"
              [src]="
                playing ? '/assets/icons/pause.svg' : '/assets/icons/play.svg'
              "
            />
          </button>
          <div class="carousel-slides">
            <div
              *ngFor="let image of carouselImage; let i = index"
              class="slide"
              [ngClass]="{ selected: activeIndex === i }"
              (click)="selectSlide(i)"
              role="button"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="breadcrumbs">
    <div
      class="digital-platform-hero-carousel digital-platform-carousel-l2-md-breadcrumbs d-none d-md-flex container"
    >
      <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
    </div>
  </ng-container>
</ng-container>
<!-- ======================================= -->

<!-- ======================================= -->
<!-- Other -->
<ng-template #carouselImageTmp>
  <ng-container *ngFor="let image of carouselImage; let i = index">
    <digital-platform-inline-image
      class="d-xl-inline-block carousel-img"
      [forceImageToContainer]="true"
      [ngClass]="{
        'previous-img': activeIndex !== i,
        'current-image': activeIndex === i
      }"
      data-automation-id="inline-image-overlay"
      [inlineImageOverride]="carouselImage[i]"
    ></digital-platform-inline-image>
  </ng-container>
</ng-template>

<ng-template #translucentImageTmp>
  <ng-container *ngFor="let image of translucentImage; let i = index">
    <digital-platform-inline-image
      class="d-sm-inline-block"
      data-automation-id="inline-image-overlay"
      [forceImageToContainer]="true"
      [inlineImageOverride]="translucentImage[i]"
    ></digital-platform-inline-image>
  </ng-container>
</ng-template>

<ng-template #mobileSectionTop>
  <div class="carousel-mobile-section-top">
    <ng-container *ngFor="let image of carouselImage; let i = index">
      <digital-platform-inline-image
        class="d-sm-inline-block carousel-mobile-img"
        [ngClass]="{
          'previous-img': activeIndex !== i,
          'current-image': activeIndex === i
        }"
        data-automation-id="inline-image-overlay"
        [forceImageToContainer]="true"
        [inlineImageOverride]="carouselImage[i]"
      ></digital-platform-inline-image>
    </ng-container>
    <svg
      class="swoop-mobile {{ swooshOverlayColor.cssColorName }}"
      width="96"
      height="316"
      viewBox="0 0 96 316"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.3375 113.312C89.2292 268.406 54.6785 310.092 2.02582 316H96V0H0C17.2342 43.2439 31.5176 85.1784 40.3375 113.312Z"
        fill=""
      />
    </svg>
  </div>
</ng-template>

<ng-template #mobileDuoTone>
  <div class="carousel-mobile-overlay {{ fillColorToBgColor }}">
    <div class="carousel-right-overlay">
      <ng-container *ngFor="let image of mobileTranslucentImage">
        <digital-platform-inline-image
          class="d-sm-inline-block carousel-mobile-img"
          data-automation-id="inline-image-overlay"
          [forceImageToContainer]="true"
          [inlineImageOverride]="image"
        ></digital-platform-inline-image>
      </ng-container>
    </div>

    <div class="carousel-bottom-content px-7">
      <div
        *ngIf="isL2"
        class="carousel-above-header"
        [innerHtml]="stringOrNullToString(textAboveTitle[activeIndex])"
      ></div>
      <h1
        class="carousel-header pb-3"
        [innerHTML]="stringOrNullToString(richTextTitle[activeIndex])"
      ></h1>
      <p
        class="carousel-right-caption pb-3"
        [innerHTML]="stringOrNullToString(description[activeIndex])"
      ></p>
      <div *ngIf="!!paragraphs">
        <ng-container *ngTemplateOutlet="ctaButton"></ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="hasControls" class="carousel-mobile-controls-container">
    <button (click)="playPause()">
      <img
        alt="play/pause button"
        [src]="playing ? '/assets/icons/pause.svg' : '/assets/icons/play.svg'"
      />
    </button>
    <div class="carousel-slides">
      <div
        *ngFor="let image of carouselImage; let i = index"
        class="slide"
        [ngClass]="{ selected: activeIndex === i }"
        (click)="selectSlide(i)"
        role="button"
      ></div>
    </div>
  </div>
</ng-template>

<ng-template #breadcrumbs>
  <div *ngIf="mobileBreadcrumbs[0]" class="mobile-breadcrumbs clearfix">
    <digital-platform-breadcrumbs-ptype
      [hideHome]="mobileBreadcrumbs[0] ? mobileBreadcrumbs[0].hideHome : false"
      [nestedBreadcrumbItem]="
        mobileBreadcrumbs[0] ? mobileBreadcrumbs[0].nestedBreadcrumbItem : []
      "
    ></digital-platform-breadcrumbs-ptype>
  </div>
</ng-template>

<ng-template #ctaButton>
  <digital-platform-cta-button
    [analyticsLinkText]="getCtaButton().analyticsLinkText || ''"
    [chevron]="getCtaButton().chevron || false"
    [ctaPosition]="getCtaButton().ctaPosition || {}"
    [ctaSize]="getCtaButton().ctaSize || {}"
    [ctaStyle]="getCtaButton().ctaStyle || {}"
    [fontAwesomeIconClass]="getCtaButton().fontAwesomeIconClass || ''"
    [marginBottomClass]="getCtaButton().marginBottomClass || {}"
    [marginTopClass]="getCtaButton().marginTopClass || {}"
    [url]="getCtaButton().url || []"
    [visibility]="getCtaButton().visibility || {}"
  ></digital-platform-cta-button>
</ng-template>
